if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((item) => {
          const button = item.querySelector('button');
          if (button) button.addEventListener('click', this.setActiveMedia.bind(this, item.dataset.target, false));
        });

        if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const current = event.detail && event.detail.currentElement;
        if (!current || !this.elements.thumbnails) return;

        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${current.dataset.mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer) return;

        let activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]:not([hidden])') ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (activeMedia && activeMedia.hidden) {
          activeMedia =
            Array.from(this.elements.viewer.querySelectorAll('[data-media-id]')).find((element) => !element.hidden) ||
            activeMedia;
        }

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');

        if (prepend && activeMedia.parentElement && activeMedia.parentElement.firstChild !== activeMedia) {
          activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider && typeof this.elements.viewer.resetPages === 'function') {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'auto' });
          }

          const rect = activeMedia.getBoundingClientRect();
          if (rect.top <= -0.5) {
            window.scrollTo({ top: rect.top + window.scrollY, behavior: 'smooth' });
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);

        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((button) => {
          button.removeAttribute('aria-current');
        });

        const button = thumbnail.querySelector('button');
        if (button) button.setAttribute('aria-current', 'true');

        if (
          typeof this.elements.thumbnails.isSlideVisible === 'function' &&
          this.elements.thumbnails.isSlideVisible(thumbnail, 10)
        ) {
          return;
        }

        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'auto' });
        }
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion) return;

        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');

          if (window.accessibilityStrings && window.accessibilityStrings.imageAvailable) {
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          }

          window.setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();

        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (this.stickyHeader) this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer || !this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');

        if (this.elements.viewer.sliderItems) {
          this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
        }
      }
    }
  );
}

(function () {
  const normalizeMetal = (value) => { const metal = String(value || '').trim().toLowerCase(); return ({silver: 'white gold', gold: 'yellow gold'})[metal] || metal; };

  function hasExplicitVariantInUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.has('variant') || params.has('option_values');
    } catch (_) {
      return false;
    }
  }

  function getScope(gallery) {
    return gallery.closest('.shopify-section') || gallery.parentElement || document;
  }

  function getSelectedMetal(gallery) {
    const scope = getScope(gallery);
    const checked = scope.querySelector('[data-gemlay-metal-picker] input[type="radio"]:checked');
    if (checked) return checked.value;

    const select = scope.querySelector('[data-gemlay-metal-picker] select');
    if (select) return select.value;

    return '';
  }

  function availableMetalGroups(gallery) {
    const values = Array.from(gallery.querySelectorAll('[id^="GalleryViewer"] [data-media-id][data-metal-color]'))
      .map((item) => normalizeMetal(item.dataset.metalColor))
      .filter(Boolean);

    return Array.from(new Set(values));
  }

  function updateCounter(gallery, totalVisible) {
    const total = gallery.querySelector('.slider-counter--total');
    const current = gallery.querySelector('.slider-counter--current');

    if (total) total.textContent = String(totalVisible);
    if (current) current.textContent = totalVisible > 0 ? '1' : '0';
  }

  function applyMetalGallery(gallery, requestedMetal) {
    if (!gallery || gallery.dataset.hasMetalGroups !== 'true') return;

    const groups = availableMetalGroups(gallery);
    if (!groups.length) return;

    let metal = normalizeMetal(requestedMetal);

    if (!groups.includes(metal)) {
      if (groups.includes('yellow gold')) metal = 'yellow gold';
      else metal = groups[0];
    }

    const viewerItems = Array.from(gallery.querySelectorAll('[id^="GalleryViewer"] [data-media-id]'));
    const thumbnailItems = Array.from(gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]'));

    const visibleMedia = [];

    const setStrictVisibility = (item, shouldShow) => {
      if (!item) return;

      item.hidden = !shouldShow;
      item.dataset.gemlayMetalHidden = shouldShow ? 'false' : 'true';
      item.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

      if (shouldShow) {
        item.style.removeProperty('display');
        item.style.removeProperty('width');
        item.style.removeProperty('min-width');
        item.style.removeProperty('max-width');
        item.style.removeProperty('margin');
        item.style.removeProperty('padding');
        item.style.removeProperty('visibility');
        item.style.removeProperty('pointer-events');
        if ('inert' in item) item.inert = false;
      } else {
        item.style.setProperty('display', 'none', 'important');
        item.style.setProperty('width', '0', 'important');
        item.style.setProperty('min-width', '0', 'important');
        item.style.setProperty('max-width', '0', 'important');
        item.style.setProperty('margin', '0', 'important');
        item.style.setProperty('padding', '0', 'important');
        item.style.setProperty('visibility', 'hidden', 'important');
        item.style.setProperty('pointer-events', 'none', 'important');
        if ('inert' in item) item.inert = true;
      }
    };

    viewerItems.forEach((item) => {
      const itemMetal = normalizeMetal(item.dataset.metalColor);
      const shouldShow = itemMetal === metal;

      setStrictVisibility(item, shouldShow);
      item.classList.remove('is-active');

      if (shouldShow) visibleMedia.push(item);
    });

    thumbnailItems.forEach((item) => {
      const itemMetal = normalizeMetal(item.dataset.metalColor);
      const shouldShow = itemMetal === metal;

      setStrictVisibility(item, shouldShow);

      const button = item.querySelector('button');
      if (button) button.removeAttribute('aria-current');
    });

    const sectionId = String(gallery.id || '').replace(/^MediaGallery-/, '');
    const modal = sectionId ? document.getElementById(`ProductModal-${sectionId}`) : null;

    if (modal) {
      viewerItems.forEach((item) => {
        const match = String(item.dataset.mediaId || '').match(/-(\d+)$/);
        const mediaId = match && match[1];
        if (!mediaId) return;

        const modalMedia = modal.querySelector(`[data-media-id="${mediaId}"]`);
        if (!modalMedia) return;

        const shouldShow = normalizeMetal(item.dataset.metalColor) === metal;

        modalMedia.hidden = !shouldShow;
        modalMedia.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

        if (shouldShow) {
          modalMedia.style.removeProperty('display');
          modalMedia.style.removeProperty('visibility');
          modalMedia.style.removeProperty('pointer-events');
        } else {
          modalMedia.style.setProperty('display', 'none', 'important');
          modalMedia.style.setProperty('visibility', 'hidden', 'important');
          modalMedia.style.setProperty('pointer-events', 'none', 'important');
        }
      });
    }

    gallery.dataset.activeMetalColor = metal;

    const firstVisible = visibleMedia[0];
    if (firstVisible) {
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(firstVisible.dataset.mediaId, false);
      } else {
        firstVisible.classList.add('is-active');
      }

      const firstThumb = thumbnailItems.find((item) => !item.hidden);
      const firstThumbButton = firstThumb && firstThumb.querySelector('button');
      if (firstThumbButton) firstThumbButton.setAttribute('aria-current', 'true');
    }

    updateCounter(gallery, visibleMedia.length);

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');

    if (viewer) {
      if (typeof viewer.resetPages === 'function') viewer.resetPages();
      if (viewer.slider) viewer.slider.scrollTo({ left: 0, behavior: 'auto' });
    }

    if (thumbnails) {
      if (typeof thumbnails.resetPages === 'function') thumbnails.resetPages();
      if (thumbnails.slider) thumbnails.slider.scrollTo({ left: 0, behavior: 'auto' });
    }
  }

  function initializeGallery(gallery) {
    if (!gallery || gallery.dataset.hasMetalGroups !== 'true') return;

    const initialMetal = hasExplicitVariantInUrl()
      ? getSelectedMetal(gallery)
      : gallery.dataset.defaultMetal || 'Yellow Gold';

    applyMetalGallery(gallery, initialMetal);
  }

  function initializeAll(root) {
    const galleries = [];

    if (root && root.matches && root.matches('media-gallery[data-has-metal-groups="true"]')) {
      galleries.push(root);
    }

    if (root && root.querySelectorAll) {
      galleries.push(...root.querySelectorAll('media-gallery[data-has-metal-groups="true"]'));
    }

    galleries.forEach(initializeGallery);
  }

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const metalPicker = target.closest('[data-gemlay-metal-picker]');
      if (!metalPicker) return;

      const scope = target.closest('.shopify-section') || document;

      scope.querySelectorAll('media-gallery[data-has-metal-groups="true"]').forEach((gallery) => {
        window.requestAnimationFrame(() => applyMetalGallery(gallery, target.value || getSelectedMetal(gallery)));
      });
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  } else {
    initializeAll(document);
  }
})();
